import { useEffect, useState } from 'react'

/**
 * Hook React pour savoir si l'écran est en mode mobile (largeur <= breakpoint)
 * @param {number} breakpoint - largeur max en px (par défaut 600)
 * @returns {boolean} true si mobile
 */
export function useIsMobile(breakpoint = 600): boolean {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false,
  )

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= breakpoint)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isMobile
}
